import store from '@/store'
import axios from '@axios'

// eslint-disable-next-line import/prefer-default-export
export const setStatistics = async (type, serviceId, referenceId = null) => {
  const medicalDept = store.getters['infoData/getMedicalDept']
  const yid = store.getters['infoData/getShaYoyangNum']
  const tid = store.getters['infoData/getShaEnLicenseNum']
  const region = store.getters['infoData/getRegion']

  axios.post('/fu/statistics/save', {
    Type: type,
    MedicalDepartmentCode: medicalDept,
    YID: yid,
    TID: tid,
    PCID: '',
    ServiceId: serviceId,
    ReferenceID: referenceId,
    Region: region
  })
    .then(() => {
    })
    .catch(() => {
    })
}

export const setStatisticsNew = async (serviceType, positionType, stateType, serviceId, referenceId = null, referenceId2 = null) => {
  const medicalDept = store.getters['infoData/getMedicalDept']
  const yid = store.getters['infoData/getShaYoyangNum']
  const tid = store.getters['infoData/getShaEnLicenseNum']
  const region = store.getters['infoData/getRegion'] ?? 0

  axios.post('/fu/statistics/save-new', {
    ServiceType: serviceType,
    PositionType: positionType,
    StateType: stateType,
    MedicalDepartmentCode: medicalDept,
    YID: yid,
    TID: tid,
    PCID: '',
    ServiceId: serviceId,
    ReferenceID: referenceId,
    ReferenceID2: referenceId2,
    Region: region,
  })
    .then(() => {
    })
    .catch(() => {
    })
}

export const setStatisticsAwait = async (type, serviceId, referenceId = null) => {
  const medicalDept = store.getters['infoData/getMedicalDept']
  const yid = store.getters['infoData/getShaYoyangNum']
  const tid = store.getters['infoData/getShaEnLicenseNum']
  const region = store.getters['infoData/getRegion']

  try {
    const result = await axios.post('/fu/statistics/save', {
      Type: type,
      MedicalDepartmentCode: medicalDept,
      YID: yid,
      TID: tid,
      PCID: '',
      ServiceId: serviceId,
      ReferenceID: referenceId,
      Region: region
    })
    return result.data.id
  } catch (err) {
    return null
  }
}

export const setStatisticsNewAwait = async (serviceType, positionType, stateType, serviceId, referenceId = null, referenceId2 = null) => {
  const medicalDept = store.getters['infoData/getMedicalDept']
  const yid = store.getters['infoData/getShaYoyangNum']
  const tid = store.getters['infoData/getShaEnLicenseNum']
  const region = store.getters['infoData/getRegion'] ?? 0

  try {
    const result = await axios.post('/fu/statistics/save-new', {
      ServiceType: serviceType,
      PositionType: positionType,
      StateType: stateType,
      MedicalDepartmentCode: medicalDept,
      YID: yid,
      TID: tid,
      PCID: '',
      ServiceId: serviceId,
      ReferenceID: referenceId,
      ReferenceID2: referenceId2,
      Region: region
    })
    return result.data.id
  } catch (err) {
    return null
  }
}
